var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAppiconBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    fill: "#0084F8",
    width: 100,
    height: 100
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_124_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_127_",
    fill: "#FFFFFF",
    points: "31.416,23.037 24.766,33.145 69.053,33.145 75.703,23.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_126_",
    fill: "#FFFFFF",
    points: "36.582,54.961 66.201,54.961 72.871,44.844 43.252,44.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_125_",
    fill: "#FFFFFF",
    points: "30.947,66.65 24.297,76.758 36.729,76.758 43.369,66.65  "
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppiconBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/appicon_blue.87b65f4c.svg";
export { ForwardRef as ReactComponent };